import {LoadingSvg} from '@/icons';

export function Loading() {
    return <div className="sidebar-search-list-loading"><LoadingSvg />加载中</div>;
}

export function Loaded() {
    return <div className="sidebar-search-list-loaded">已展示全部结果</div>;
}

export function NoResult() {
    return <div className="sidebar-search-list-null">未找到相关结果</div>;
}

interface IError {
    onReload: () => void;
}
export function LoadError(props: IError) {
    const {onReload} = props;
    return <div className="sidebar-search-list-error">加载失败，<span onClick={onReload}>点击重试</span></div>;
}
